import { Navigate, Outlet, useLocation } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import { Box } from "@mui/material";
import BottomNavBar from "../components/navigation/BottomNavBar";

const isTokenValid = (token) => {
    if (!token) return false;
    try {
        const decoded = jwtDecode(token);
        // exp ist in Sekunden, Date.now() in Millisekunden
        return decoded.exp * 1000 > Date.now();
    } catch {
        return false;
    }
};

const ProtectedRoute = () => {
    const location = useLocation();
    const token = localStorage.getItem("token");

    if (!isTokenValid(token)) {
        localStorage.removeItem("token");
        localStorage.removeItem("user");
        return <Navigate to={`/auth?returnTo=${location.pathname}`} replace />;
    }

    return (
        <Box sx={{ pb: '80px' }}>
            <Outlet />
            <BottomNavBar />
        </Box>
    );
};

export default ProtectedRoute;